import { __decorate } from "tslib";
import { property } from 'lit/decorators.js';
import { DedupeMixin, wasApplied } from './dedupe.js';
export const ElementVisibleMixin = (Base) => {
    if (wasApplied(ElementVisibleMixin, Base)) {
        return Base;
    }
    class Mixin extends Base {
        constructor() {
            super(...arguments);
            this.thresholds = [0.0, 0.25, 0.5, 0.75, 1.0];
            this.rootMargin = '0px';
            this.ratioMinimum = 0.1;
            this.removeObserverWhenVisible = true;
            this.intersection = { isVisible: false, isIntersecting: false, ratio: 0.0 };
        }
        connectedCallback() {
            super.connectedCallback();
            this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
                root: null,
                rootMargin: this.rootMargin,
                threshold: this.thresholds,
            });
            this.intersectionObserver.observe(this);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            if (this.intersectionObserver) {
                this.intersectionObserver.disconnect();
            }
        }
        /**
        look for changes in updated lifecycle callback
    
        updated(changedProperties: PropertyValues): void {
          super.updated(changedProperties);
    
          if (changedProperties.has('intersection')) {
            if (this.intersection.isVisible) {
              // DO SOMETHING
            }
          }
        }
        */
        handleIntersection(entries, _observer) {
            entries.forEach((entry) => {
                const ratio = Number(entry.intersectionRatio).toFixed(2) || 0.0;
                this.intersection = {
                    isVisible: Boolean(ratio >= this.ratioMinimum),
                    isIntersecting: entry.isIntersecting,
                    ratio: ratio,
                };
                if (this.intersection.isVisible && this.removeObserverWhenVisible) {
                    this.intersectionObserver.disconnect();
                }
            });
        }
    }
    __decorate([
        property({ type: Object })
    ], Mixin.prototype, "intersection", void 0);
    DedupeMixin(ElementVisibleMixin, Mixin);
    return Mixin;
};
//# sourceMappingURL=element-visible.js.map